import { VFC, useMemo } from 'react';
import { OtherDeviceCategory } from '@enmon/commons';
import { FormattedMessage, useIntl } from 'react-intl';
import { useMeterModelSuggestionsStore } from '../../../store/useMeterModelSuggestionsStore';
import { getSelectOptionsWithSuggestions } from '../utils/getSelectOptionsWithSuggestions';
import { deviceCategoryTranslated } from '../../Form/meter_details/constants';
import { Select } from '../Select';
import { MeterDetails as messages } from '../../Form/meter_details/messages';

interface OtherDeviceCategorySelectProps {
  value?: OtherDeviceCategory;
  onChange?: (value: OtherDeviceCategory) => void;
}

export const OtherDeviceCategorySelect: VFC<OtherDeviceCategorySelectProps> = ({
  ...restProps
}: OtherDeviceCategorySelectProps) => {
  const intl = useIntl();
  const { meterModelSuggestions } = useMeterModelSuggestionsStore();

  const deviceCategoryOptions = useMemo(
    () =>
      getSelectOptionsWithSuggestions({
        intl,
        values: Object.values(OtherDeviceCategory),
        suggestedValue: meterModelSuggestions?.deviceCategory?.value,
        suggestedSelection: meterModelSuggestions?.deviceCategory?.selection,
        labelFormatter: (value: OtherDeviceCategory) => intl.formatMessage(deviceCategoryTranslated[value]),
      }),
    [meterModelSuggestions, intl],
  );

  return (
    <Select
      allowClear
      showArrow
      className="w-100"
      options={deviceCategoryOptions}
      placeholder={<FormattedMessage {...messages.selectDeviceType} />}
      {...restProps}
    />
  );
};
